(function () {
  'use strict';
  if (window.aonaAuditUiReady) return;
  window.aonaAuditUiReady = true;
  function start() {
    var contacts = document.querySelector('.float-contact-btns');
    if (contacts) {
      var actions = Array.from(contacts.children);
      var toggle = document.createElement('button');
      toggle.type = 'button'; toggle.className = 'aona-contact-toggle';
      toggle.textContent = 'Help'; toggle.setAttribute('aria-expanded', 'false');
      actions.forEach(function (action) { action.hidden = true; });
      contacts.classList.add('aona-contact-collapsible'); contacts.appendChild(toggle);
      function expand(open) {
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? 'Close help' : 'Help';
        actions.forEach(function (action) { action.hidden = !open; });
      }
      toggle.addEventListener('click', function () { expand(toggle.getAttribute('aria-expanded') !== 'true'); });
      contacts.addEventListener('keydown', function (event) { if (event.key === 'Escape') { expand(false); toggle.focus(); } });
    }
    var nav = document.querySelector('.aona-bottom-nav');
    var purchase = document.querySelector('.vessel-mobile-sticky-bar, .aona-mob-sticky-bar');
    function clearances() {
      var navHeight = nav && nav.getClientRects().length ? nav.getBoundingClientRect().height : 0;
      var buyHeight = purchase && purchase.getClientRects().length ? purchase.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--aona-bottom-clearance', navHeight + 'px');
      document.documentElement.style.setProperty('--aona-purchase-clearance', buyHeight + 'px');
      document.body.classList.toggle('aona-has-purchase-bar', buyHeight > 0);
    }
    clearances();
    if (window.ResizeObserver) { var resize = new ResizeObserver(clearances); if (nav) resize.observe(nav); if (purchase) resize.observe(purchase); }
    window.addEventListener('resize', clearances, { passive: true });
    var scrolling = false;
    window.addEventListener('scroll', function () {
      if (scrolling) return; scrolling = true;
      requestAnimationFrame(function () { document.body.classList.toggle('aona-header-scrolled', window.scrollY > 100); scrolling = false; });
    }, { passive: true });

    // Keep keyboard focus within the topmost visible modal, without changing its close/auth handlers.
    var active = null, previous = null, inert = new Map();
    var selector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function visible(node) { return node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'; }
    function controls(dialog) { return Array.from(dialog.querySelectorAll(selector)).filter(visible); }
    function restore() { inert.forEach(function (value, node) { node.inert = value; }); inert.clear(); }
    function sync() {
      var dialogs = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).filter(function(dialog) { return visible(dialog) && dialog.id !== 'aona-filter-sidebar'; });
      var next = dialogs.length ? dialogs[dialogs.length - 1] : null;
      var consent = document.getElementById('shopify-pc__banner');
      var consentInFront = !!(next && consent && visible(consent));
      document.body.classList.toggle('aona-cookie-priority', consentInFront);
      if (consentInFront) next = consent;
      if (next === active) return;
      restore();
      if (!next) { active = null; if (previous && previous.isConnected && visible(previous)) previous.focus(); previous = null; return; }
      if (!active) previous = document.activeElement;
      active = next; active.setAttribute('tabindex', '-1');
      var branch = active;
      while (branch.parentElement && branch.parentElement !== document.documentElement) {
        Array.from(branch.parentElement.children).forEach(function (sibling) {
          if (sibling !== branch && sibling.tagName !== 'SCRIPT' && sibling.tagName !== 'STYLE') { inert.set(sibling, sibling.inert); sibling.inert = true; }
        }); branch = branch.parentElement;
      }
      if (!active.contains(document.activeElement)) (controls(active)[0] || active).focus();
    }
    document.addEventListener('keydown', function (event) {
      if (!active) return;
      if (event.key === 'Escape') {
        var close = active.querySelector('button[aria-label*="Close"],button[aria-label*="close"],#modal-close-btn,#aona-qv-close');
        if (close) { event.preventDefault(); close.click(); }
        return;
      }
      if (event.key !== 'Tab') return;
      var list = controls(active), first = list[0], last = list[list.length - 1];
      if (!first) { event.preventDefault(); active.focus(); }
      else if (event.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('focusin', function (event) { if (active && !active.contains(event.target)) (controls(active)[0] || active).focus(); });
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    }).observe(document.body, { subtree:true, attributes:true, attributeFilter:['style','class','hidden','aria-modal'], childList:true });
    sync();
    var policyHeadings = ['Territorial Scope','Return Window','Return Eligibility','Non-Returnable Items','How to Initiate a Return/Exchange','Damages and Incorrect Items','Return Shipping Costs','Sale Purchases','Exchanges','Refunds','Contact'];
    document.querySelectorAll('.shopify-policy__body p').forEach(function(paragraph) {
      var text = paragraph.textContent.trim();
      if (text.indexOf('###') !== 0) return;
      var title = policyHeadings.find(function(heading) { return text.slice(3).trim().indexOf(heading) === 0; });
      if (!title) return;
      var walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim().indexOf('###') === 0) { node.nodeValue = node.nodeValue.replace(/^\s*###\s*/, '').replace(title, '').trimStart(); break; }
      }
      var heading = document.createElement('h2'); heading.textContent = title; paragraph.before(heading);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

